import { IMsg } from '_c/typings/model/im';
import { MsgL2Type } from '_c/typings/proto';

export function createMessageUniqueKey(messageData: IMsg): string {
  const key = `message_${messageData.channelMsg.channelId ?? ''}_${messageData.origin?.sequence ?? ''}`;
  return key ?? `message_${messageData.channelMsg.channelId ?? ''}_${Date.now()}`;
}

/**
 * 检查消息是否可以合并 TODO: 后续要合并到init-message-config中
 * @param msg
 */
const checkCanBeMerged = (msg: IMsg) => (
  [
    MsgL2Type.MsgL2TypeText, MsgL2Type.MsgL2TypePic, MsgL2Type.MsgL2TypeSticker,
  ].indexOf(msg.l2Type) > -1 && !msg.origin?.isRevoked && !msg.replyMsg && !(msg?.msgTopicData?.itemList?.length)
);

/**
 * 检查消息是否可以合并 注意发送失败消息还可合并，不要使用任何跟origin有关的字段
 * @param curMsg
 * @param lastMsg
 */
export function checkNeedMerge(curMsg: IMsg, lastMsg: IMsg | undefined) {
  // 传入了前置消息，需要根据前置消息判断是否需要合并消息
  if (checkCanBeMerged(curMsg) && lastMsg && checkCanBeMerged(lastMsg)) {
    // 同一个用户发的消息
    if (String(curMsg.senderUid) === String(lastMsg.senderUid)) {
      if (Number(curMsg.senderUid) > 0 && lastMsg.mergeSendTime) {
        // 前置消息存在合并的逻辑
        const curMsgTime = Number(curMsg.ts) ?? 0;
        const timeDis = curMsgTime - lastMsg.mergeSendTime;
        if (timeDis >= 0 && timeDis < 2 * 60) {
          // 在合并的时间间隔内
          // eslint-disable-next-line no-param-reassign
          curMsg.mergeSendTime = lastMsg.mergeSendTime;
          // eslint-disable-next-line no-param-reassign
          curMsg.needMerge = true;
          return {
            mergeSendTime: lastMsg.mergeSendTime,
            needMerge: true,
          };
        }
      }
    }
  }
  // eslint-disable-next-line no-param-reassign
  curMsg.mergeSendTime = Number(curMsg.ts);
  // eslint-disable-next-line no-param-reassign
  curMsg.needMerge = false;
  return {
    mergeSendTime: Number(curMsg.ts),
    needMerge: false,
  };
}
